<template>
  <b-modal
    id="account-deleted-modal"
    title="Your account has been deleted"
    centered
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="message">
      You’ll now be logged out and redirected to the home screen.
    </div>
    <template slot="modal-footer">
      <b-container>
        <b-row>
          <b-col>
            <b-btn
              class="ok-button"
              block
              pill
              variant="primary"
              @click="logout"
            >
              Okay
            </b-btn>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";

export default {
  methods: {
    confirmDeleteAccount() {
      this.$root.$emit("bv::hide::modal", "delete-account-modal");
    },
    async logout() {
      await this.$store.dispatch("auth/logout");

      if (this.$route.name != "Home")
        this.$router.push({ path: "/" + this.subdomain });
    },
  },
  computed: {
    ...mapState("merchant", ["subdomain"]),
  },
};
</script>

<style lang="scss">
#account-deleted-modal {
  .modal-dialog {
    max-width: 381px !important;
  }
  .modal-header {
    padding-top: 20px;
    padding-bottom: 0;
    border-bottom-width: 0;
  }
  .modal-footer {
    border-top-width: 0;
    padding-bottom: 25px;
  }
  .modal-title {
    padding-left: 42px;
  }
  .modal-content {
    border-radius: 8px;
  }
  .message {
    color: #49545c;
    padding-left: 42px;
    padding-right: 42px;
    font-size: 14px;
    text-align: center;
  }
  button:focus {
    outline-width: 0;
  }
  .ok-button:hover,
  .ok-button:focus {
    background-color: #ff8a00;
    border-color: #ff8a00;
    filter: brightness(95%);
  }
}
</style>